import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  token: null,
  admin: null,
  /** @type {string[]} */
  permissions: [],
  authHydrated: false,
  status: 'idle',
  error: null,
}

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setCredentials(state, action) {
      const { token, admin } = action.payload
      state.token = token
      state.admin = admin ?? null
      state.permissions = admin?.permissions?.length ? admin.permissions : []
      state.authHydrated = Boolean(!token || admin)
      state.error = null
      state.status = 'idle'
    },
    setAdmin(state, action) {
      state.admin = action.payload
      state.permissions = action.payload?.permissions?.length
        ? action.payload.permissions
        : []
      state.authHydrated = true
    },
    setAuthHydrated(state, action) {
      state.authHydrated = Boolean(action.payload)
    },
    logout(state) {
      state.token = null
      state.admin = null
      state.permissions = []
      state.authHydrated = true
      state.error = null
      state.status = 'idle'
    },
    setAuthError(state, action) {
      state.error = action.payload
      state.status = 'failed'
    },
  },
})

export const { setCredentials, setAdmin, setAuthHydrated, logout, setAuthError } = authSlice.actions
export default authSlice.reducer
